/** chunk detail lazy loading hook */

import { useQuery, keepPreviousData } from "@tanstack/react-query";
import queries from "@/queries";

export const useChunkDetail = (
  comparisonId: string | null,
  chunkId: string | null,
) => {
  const factory = queries
    .comparison(comparisonId ?? "")
    ._ctx.chunk(chunkId ?? "");

  return useQuery({
    ...factory,
    enabled: !!comparisonId && !!chunkId,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
};
